<template>
	<div>
		<el-dialog :visible.sync="visible" :close-on-click-modal="false" @close="$emit('update:show', false)"
			 :append-to-body="true" width="500px">
			<div slot="title" class="header-title">
				<img src="../../assets/img/common/tab_logo2.png" width="340">
			</div>
			<div v-if="opeType==='login'">
				<div class="loginTab">
					<a href="javascript:;" @click="tab(true)" :class="isPhone?'loginTab-c':''">手机登录</a>
					<a href="javascript:;" @click="tab(false)" :class="isPhone?'':'loginTab-c'">密码登录</a>
				</div>
				<div class="loginBox">
					<el-form :model="formData" ref="login" @submit.prevent="login()" :rules="loginrule">
						<el-form-item label="用户名" prop="userName" v-if="!isPhone">
							<el-input type="text" v-model="formData.userName" maxlength="30"
								placeholder="请输入用户名/手机号码" />
						</el-form-item>
						<el-form-item label="登录密码" prop="password" v-if="!isPhone" class="fixHeight">
							<el-input type="password" v-model="formData.password" maxlength="50"
								placeholder="请输入登录密码" />
						</el-form-item>
						<el-checkbox-group v-model="autoLogin" v-if="!isPhone" class="autoLogin">
							<el-checkbox label="记住密码" value="true" key="autoLoginKey"></el-checkbox>
						</el-checkbox-group>

						<el-form-item label="手机号码" prop="phone" v-if="isPhone">
							<el-input type="text" v-model="formData.phone" maxlength="20" placeholder="请输入手机号码" />
						</el-form-item>
						<!--验证码-->
						<el-form-item style="margin-top:10px" prop="checkCode" v-if="isPhone">
							<div style="width:100%">
								<div style="display:inline-block;height:50px;width:100px" @click="getCheckCode()">
									<img v-if="checkCodeUrl" style="height:50px;width:100px" :src="checkCodeUrl"/>
								</div>
								<span style="color:#409EFF;cursor:pointer;" @click="getCheckCode()" >看不清？换一张</span>
								<el-input  v-model="formData.checkCode" maxlength="50"
									placeholder="请输入5位验证码" style="width:160px" />
							</div>
						</el-form-item>
						<el-form-item label="手机验证码" prop="code" v-if="isPhone" class="register-code">
							<el-input type="text" v-model="formData.code" maxlength="10" placeholder="请输入手机验证码" />
							<a href="javascript:;" class="border0 c-ffffff" style="cursor: not-allowed;background-color: #ccc !important;"
								v-if="!isDown && formData.checkCode.length != 5">获取验证码</a>
							<a href="javascript:;" class="bgc-4492ff border0 c-ffffff" @click="getCode('login')"
								v-if="!isDown && formData.checkCode.length === 5">获取验证码</a>
							<a href="javascript:;" class="bgc-999999 border0 c-ffffff" v-if="isDown && formData.checkCode.length === 5">{{downTime}}</a>
						</el-form-item>
						<el-button type="primary" @click="login('login')" class="loginBotton">马上登录</el-button>
					</el-form>
				</div>
				<div class="loginLink">
					<a href="javascript:;" class="loginReg" @click="toReg('register')">用户注册</a>
					<a href="javascript:;" class="loginFind" @click="toReg('find')">忘记密码</a>
				</div>
				<div class="other-login">
					<p>其他登录方式</p>
					<p>
						<img src="../../assets/img/common/wc.png" @click="toLogin('wc')" width="40">
						<img src="../../assets/img/common/qq.png" @click="toLogin('qq')" width="35">
						<img src="../../assets/img/common/sn.png" @click="toLogin('sn')" width="40">
					</p>
				</div>
			</div>
			<div v-if="opeType=='register'">
				<p class="register-title">用户注册</p>
				<div class="loginBox">
					<el-form :model="formData2" ref="register" @submit.prevent="register()" :rules="registerrule">
						<el-form-item label="手机号码" prop="rphone">
							<el-input type="text" v-model="formData2.rphone" maxlength="20" placeholder="请输入手机号码" />
						</el-form-item>
						<!--验证码-->
						<el-form-item style="margin-top:10px" prop="checkCode">
							<div style="width:100%">
								<div style="display:inline-block;height:50px;width:100px" @click="getCheckCode()">
									<img v-if="checkCodeUrl" style="height:50px;width:100px" :src="checkCodeUrl" />
								</div>
								<span style="color:#409EFF;cursor:pointer;" @click="getCheckCode()">看不清？换一张</span>
								<el-input  v-model="formData2.checkCode" maxlength="50"
									placeholder="请输入5位验证码" style="width:160px" />
							</div>
						</el-form-item>
						<el-form-item label="手机验证码" prop="rcode" class="register-code">
							<el-input type="text" v-model="formData2.rcode" maxlength="10" placeholder="请输入手机验证码" />
							<a href="javascript:;" class="border0 c-ffffff" style="cursor: not-allowed;background-color: #ccc !important;"
								v-if="!isDown && formData2.checkCode.length != 5">获取验证码</a>
							<a href="javascript:;" class="bgc-4492ff border0 c-ffffff"
								@click="getCode('register')" v-if="!isDown && formData2.checkCode.length === 5">获取验证码</a>
							<a href="javascript:;" class="bgc-999999 border0 c-ffffff" v-if="isDown && formData2.checkCode.length === 5">{{downTime}}</a>	
						</el-form-item>
						<div class="clear">
							<el-checkbox-group v-model="hasRead" class="hasRead">
								<el-checkbox label="我已阅读并同意"></el-checkbox>
							</el-checkbox-group>
							<a href="javascript:;" @click="open()" class="hasRead-rule">《用户注册服务条款和声明》</a>
						</div>
						<el-button type="primary" @click="register('register')" class="loginBotton">马上注册</el-button>
					</el-form>
				</div>
				<div class="loginLink">
					<a href="javascript:;" class="loginReg" @click="toReg('login')">返回登录</a>
					<a href="javascript:;" class="loginFind" @click="toReg('find')">忘记密码</a>
				</div>
				<p style="padding:34px 0 0 0;"></p>
			</div>
			<div v-if="opeType=='find'">
				<p class="register-title">重置密码</p>
				<div class="loginBox">
					<el-form :model="formDataf" ref="find" @submit.prevent="find()" :rules="findrule">
						<el-form-item label="手机号码" prop="fphone">
							<el-input type="text" v-model="formDataf.fphone" maxlength="20" placeholder="请输入手机号码" />
						</el-form-item>
						<!--验证码-->
						<el-form-item style="margin-top:10px" prop="checkCode">
							<div style="width:100%">
								<div style="display:inline-block;height:50px;width:100px" @click="getCheckCode()">
									<img v-if="checkCodeUrl" style="height:50px;width:100px"  :src="checkCodeUrl" />
								</div>
								<span style="color:#409EFF;cursor:pointer;" @click="getCheckCode()">看不清？换一张</span>
								<el-input  v-model="formDataf.checkCode" maxlength="50"
									placeholder="请输入5位验证码" style="width:160px" />
							</div>
						</el-form-item>
						<el-form-item label="手机验证码" prop="fcode" class="register-code">
							<el-input type="text" v-model="formDataf.fcode" maxlength="10" placeholder="请输入手机验证码" />
							<a href="javascript:;" class="border0 c-ffffff" style="cursor: not-allowed;background-color: #ccc !important;"
								v-if="!isDown && formDataf.checkCode.length != 5">获取验证码</a>
							<a href="javascript:;" class="bgc-4492ff border0 c-ffffff"
								@click="getCode('resetPwd')" v-if="!isDown && formDataf.checkCode.length === 5">获取验证码</a>
							<a href="javascript:;" class="bgc-999999 border0 c-ffffff" v-if="isDown && formDataf.checkCode.length === 5">{{downTime}}</a>		
						</el-form-item>
						<el-button type="primary" @click="find('find')" class="loginBotton">马上重置</el-button>
					</el-form>
				</div>
				<div class="loginLink">
					<a href="javascript:;" class="loginReg" @click="toReg('login')">返回登录</a>
					<a href="javascript:;" class="loginFind" @click="toReg('register')">用户注册</a>
				</div>
				<p class="register-text"></p>
			</div>
			<div v-if="opeType=='reset'">
				<p class="register-title">重置密码</p>
				<div class="loginBox">
					<el-form :model="formDatas" ref="reset" @submit.prevent="reset()" :rules="resetrule">
						<el-form-item label="修改密码" prop="password">
							<el-input type="password" v-model="formDatas.password" maxlength="50" placeholder="重置密码" />
						</el-form-item>
						<el-form-item label="确认密码" prop="repassword">
							<el-input type="password" v-model="formDatas.repassword" maxlength="50"
								placeholder="确认密码" />
						</el-form-item>
						<el-button type="primary" @click="reset('reset')" class="loginBotton">马上重置</el-button>
					</el-form>
				</div>
				<div class="loginLink">
					<a href="javascript:;" class="loginReg" @click="toReg('login')">返回登录</a>
					<a href="javascript:;" class="loginFind" @click="toReg('register')">用户注册</a>
				</div>
				<p class="register-text"></p>
			</div>
			<div v-if="opeType=='identify'">
				<p class="identify-title">注册成功</p>
				<p class="identify-text">您可继续完成身份认证，认证后可进行更多操作</p>
				<p class="identifyBotton">
					<a href="javascript:;" @click="showIdentify()">马上认证</a>
				</p>
				<p class="identifyCancel">
					<a href="javascript:;" @click="close()">跳过认证</a>
				</p>
				<identify :show.sync="ishow" pageName="login" @fatherClose="close"></identify>
			</div>
		</el-dialog>
		<rule :show.sync="rshow"></rule>
		<valid :show.sync="vshow" @toSend="sendChange"></valid>
	</div>
</template>

<script>
	import rule from './rule_dialog.vue';
	import valid from './valid.vue';
	import {
		setCookie,
		getCookie,
		delCookie
	} from '../../utils/cookie.js';
	import identify from './identify.vue';
	export default {
		data() {
			var isMobileNumber = (rule, value, callback) => {
				if (!value) {
					return new Error("请输入电话号码");
				} else {
					const reg = this.global.phoneReg;
					const isPhone = reg.test(value);
					value = Number(value); //转换为数字
					if (typeof value === "number" && !isNaN(value)) { //判断是否为数字
						value = value.toString(); //转换成字符串
						if (value.length < 0 || value.length > 12 || !isPhone) { //判断是否为11位手机号
							callback(new Error("请输入正确的手机号码"));
						} else {
							if (this.opeType == 'login') {
								if (this.isPhone) {
									this.$axios.get(this.global.url + 'cl/isPhone', {
										params: {
											phone: value
										}
									}).then(res => {
										var code = res.data.code;
										if (code == 200) {
											callback('此手机号码未注册');
										} else {
											callback();
										}
									});
								} else {
									callback();
								}
							} else {
								this.$axios.get(this.global.url + 'cl/isPhone', {
									params: {
										phone: value
									}
								}).then(res => {
									var code = res.data.code;
									if (this.opeType == 'find') {
										if (code == 200) {
											callback('此手机号码未注册');
										} else {
											callback();
										}
									} else if (this.opeType == 'register') {
										if (code == 200) {
											callback();
										} else {
											callback(res.data.msg);
										}
									}
								});
							}
						}
					} else {
						callback(new Error("请输入电话号码"));
					}
				}
			};

			var checkPassword = (rule, value, callback) => {
				if (this.formDatas.password) {
					if (this.formDatas.password != value) {
						callback(new Error("两次输入的密码不一致"));
					} else {
						callback();
					}
				} else {
					callback(new Error("请输入密码"));
				}
			};

			return {
				visible: this.show,
				data_jtype: this.jtype,
				isPhone: true,
				rshow: false,
				vshow: false,
				isDown: false,
				downTime: 60,
				opeType: 'login',
				autoLogin: false,
				ishow: false,
				hasRead: false,
				type: '',
				checkCodeUrl:"https://www.ditcc.com/sysCode/getCode",
				formData: {
					userName: '',
					password: '',
					phone: '',
					code: '',
					checkCode:""
				},
				formData2: {
					rphone: '',
					rcode: '',
					checkCode:""
				},
				formDataf: {
					fphone: '',
					fcode: '',
					checkCode:""
				},
				formDatas: {
					password: '',
					repassword: '',
					checkCode:""
				},
				loginrule: {
					userName: [{
							required: true,
							message: '请输入用户名/手机号码',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '用户名长度不正确',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入登录密码',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '登录密码长度不正确',
							trigger: 'blur'
						}
					],
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							validator: isMobileNumber,
							trigger: 'blur'
						}
					],
					code: [{
							required: true,
							message: '请输入手机验证码',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 4,
							message: '手机验证码长度不正确',
							trigger: 'blur'
						}
					]
				},
				registerrule: {
					rphone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							validator: isMobileNumber,
							trigger: 'blur'
						}
					],
					rcode: [{
							required: true,
							message: '请输入手机验证码',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 4,
							message: '手机验证码长度不正确',
							trigger: 'blur'
						}
					]
				},
				findrule: {
					fphone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							validator: isMobileNumber,
							trigger: 'blur'
						}
					],
					fcode: [{
							required: true,
							message: '请输入手机验证码',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 4,
							message: '手机验证码长度不正确',
							trigger: 'blur'
						}
					]
				},
				resetrule: {
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '密码长度不正确',
							trigger: 'blur'
						}
					],
					repassword: [{
							required: true,
							message: '请再次输入密码',
							trigger: 'blur'
						},
						{
							validator: checkPassword,
							trigger: 'blur'
						}
					]
				}
			}
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			jtype: ''
		},
		watch: {
			show() {
				this.visible = this.show;
				this.data_jtype = this.jtype;
			}
		},
		mounted() {
			var autoLogin = getCookie('autoLogin');
			if (autoLogin) {
				var u = getCookie('userName');
				var p = getCookie('password');
				if (u && p) {
					this.formData.userName = u.toString();
					this.formData.password = p.toString();
					this.autoLogin = true;
				}
			}
		},
		components: {
			rule,
			identify,
			valid
		},
		methods: {
			login(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let fd = new FormData();

						if (this.isPhone) {
							fd.append('phone', this.formData.phone);
							fd.append('code', this.formData.code);
						} else {
							fd.append('userName', this.formData.userName);
							fd.append('password', this.formData.password);
							if (this.autoLogin) {
								setCookie('autoLogin', '1', 30);
								setCookie('userName', this.formData.userName, 30);
								setCookie('password', this.formData.password, 30);
							} else {
								delCookie('autoLogin');
								delCookie('userName');
								delCookie('password');
							}
						}
						this.$axios.post(this.global.url + 'cl/login', fd).then(res => {
							var code = res.data.code;
							if (code == 200) {
								this.visible = false;
								if (this.data_jtype) {
									var jt = this.data_jtype;
									if (jt == 'projectAdd') {
										this.$router.push({
											path: "/user/projectAdd"
										})
									} else if (jt == 'projectDemAdd') {
										this.$router.push({
											path: "/user/projectDemAdd"
										})
									} else if (jt == 'expRegister') {
										this.$router.push({
											path: "/register/expRegister"
										})
									} else if (jt == 'orgRegister') {
										this.$router.push({
											path: "/orgn/list"
										})
									} else if (jt == 'projectResAdd') {
										this.$router.push({
											path: "/user/projectResAdd"
										})
									} else if (jt == 'expertDemAdd') {
										this.$router.push({
											path: "/user/expertDemAdd"
										})
									} else if (jt == 'sub') {
										this.$router.push({
											path: "/info/sub"
										})
									} else if (jt == 'user') {
										this.$router.push({
											path: "/user/userInfo"
										})
									}
								} else {
									this.$parent.toload();
								}
							} else {
								var msg = res.data.msg;
								this.$message.error(msg);
							}
						}).catch(err => {
							// error callback
						});
					} else {
						return false
					}
				})
			},
			register(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.hasRead) {
							let fd = new FormData();
							fd.append('phone', this.formData2.rphone);
							fd.append('code', this.formData2.rcode);
							fd.append('type', 'new');
							this.$axios.post(this.global.url + 'cl/register', fd).then(res => {
								var code = res.data.code;
								if (code == 200) {
									this.opeType = 'identify';
								} else {
									var msg = res.data.msg;
									this.$message.error(msg);
								}
							}).catch(err => {});
						} else {
							this.$message.error("请阅读并勾选同意《用户注册服务条款和声明》")
						}
					} else {
						return false
					}
				})
			},
			find(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let fd = new FormData();
						fd.append('phone', this.formDataf.fphone);
						fd.append('code', this.formDataf.fcode);
						fd.append('type', 'resetPwd');
						this.$axios.post(this.global.url + 'sendSms/checkCode', fd).then(res => {
							var code = res.data;
							if (code) {
								this.opeType = 'reset'
							} else {
								this.$message.error('验证码已失效，请重新获取');
							}
						}).catch(err => {
							// error callback
						});
					} else {
						return false
					}
				})
			},
			reset(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let fd = new FormData();
						fd.append('phone', this.formDataf.fphone);
						fd.append('password', this.formDatas.password);
						this.$axios.post(this.global.url + 'cl/resetPwd', fd).then(res => {
							var code = res.data.code;
							if (code == 200) {
								this.$message.info('重置密码成功');
								this.opeType = 'login';
								this.tab(false);
							} else {
								var msg = res.data.msg;
								this.$message.error(msg);
							}
						}).catch(err => {
							// error callback
						});
					} else {
						return false
					}
				})
			},
			tab(isPhone) {
				this.isPhone = isPhone;
				this.$refs['login'].clearValidate();
				this.formData.code = null;
				this.formData2.rcode = null;
				this.formDataf.fcode = null;
			},
			open() {
				this.rshow = true;
			},
			toReg(login) {
				this.opeType = login
				this.getCheckCode()//获取新的二维码
				if (login == 'register') {
					if (this.formData.phone) {
						this.formData2.rphone = this.formData.phone
					}
				}
				this.formData.checkCode = '';
				this.formData2.checkCode = '';
				this.formDataf.checkCode = '';
				this.formData.code = null;
				this.formData2.rcode = null;
				this.formDataf.fcode = null;
			},
			toLogin(type) {
				window.open(this.global.base + 'cl/oaLogin?type=' + type)
			},
			getCode(type) {
				//this.vshow = true;
				this.type = type;
				if (type == 'login') {
					this.$refs.login.validateField('phone', (phone_check) => {
						if (phone_check) {
							return;
						} else {
							if(!this.formData.checkCode){
								this.$message({
									message: '请输入验证码',
									type: 'warning'
								});
								return;
							}
							if(this.formData.checkCode.length === 5){
								this.loadCode(this.formData.phone, type, this.formData.checkCode)
							}else{
								this.$message({
									message: '请输入5位验证码',
									type: 'warning'
								});
								return;
							}
						}
					})
				} else if (type == 'register') {
					this.$refs.register.validateField('rphone', (phone_check) => {
						if (phone_check) {
							return;
						} else {
							if(!this.formData2.checkCode){
								this.$message({
									message: '请输入验证码',
									type: 'warning'
								});
								return;
							}
							if(this.formData2.checkCode.length === 5){
								this.loadCode(this.formData2.rphone, type, this.formData2.checkCode)
							}else{
								this.$message({
									message: '请输入5位验证码',
									type: 'warning'
								});
								return;
							}
						}
					})
				} else if (type == 'resetPwd') {
					this.$refs.find.validateField('fphone', (phone_check) => {
						if (phone_check) {
							return;
						} else {
							if(!this.formDataf.checkCode){
								this.$message({
									message: '请输入验证码',
									type: 'warning'
								});
								return;
							}
							if(this.formDataf.checkCode.length === 5){
								this.loadCode(this.formDataf.fphone, type, this.formDataf.checkCode)
							}else{
								this.$message({
									message: '请输入5位验证码',
									type: 'warning'
								});
								return;
							}
						}
					})
				}
			},
			//获取验证码图片
			getCheckCode(){
				this.checkCodeUrl = this.checkCodeUrl +"?v=" + new Date().getTime()
				console.log('点击获取验证码', this.checkCodeUrl)
			},
			loadCode(phone, type, checkCode) {
				console.log(checkCode, '验证码')
				this.$axios.get(this.global.url + '/sendSms/send', {
					params: {
						phone: phone,
						type: type,
						code:checkCode
					}
				}).then(res => {
					console.log(res, '返回短信验证结果')
					if(res.data.code === 200){
						this.isDown = true;
						this.downTime = 60;
						this.timer = setInterval(() => {
							this.downTime--;
							if (this.downTime === 0) {
								this.isDown = false;
								clearInterval(this.timer)
							}
						}, 1000)
					}else{
						this.$message({
							message: res.data.msg,
							type: 'error'
						});
					}
					
					// if (type == 'login') {
					// 	this.formData.code = res.data.msg
					// } else if (type == 'register') {
					// 	this.formData2.rcode = res.data.msg
					// } else if (type == 'resetPwd') {
					// 	this.formDataf.fcode = res.data.msg
					// }
				}).catch(e => {})
			},
			close() {
				this.visible = false;
				this.$parent.toload();
			},
			showIdentify() {
				this.ishow = true;
			},
			sendChange() {
				var type = this.type;
				if (type == 'login') {
					this.$refs.login.validateField('phone', (phone_check) => {
						if (phone_check) {
							return;
						} else {
							this.loadCode(this.formData.phone, type, this.formData.checkCode)
						}
					})
				} else if (type == 'register') {
					this.$refs.register.validateField('rphone', (phone_check) => {
						if (phone_check) {
							return;
						} else {
							this.loadCode(this.formData2.rphone, type, this.formData2.checkCode)
						}
					})
				} else if (type == 'resetPwd') {
					this.$refs.find.validateField('fphone', (phone_check) => {
						if (phone_check) {
							return;
						} else {
							this.loadCode(this.formDataf.fphone, type, this.formDataf.checkCode)
						}
					})
				}
			}
		}
	};
</script>

<style scoped>
	.header-title {
		padding: 0 0 0 40px;
	}

	.loginTab {
		width: 368px;
		margin: 0 auto;
		border-bottom: 2px solid #522e95;
	}

	.loginTab a {
		display: inline-block;
		width: 182px;
		text-align: center;
		font-size: 16px;
		padding: 10px 0;
	}

	.loginTab-c {
		background: #522e95;
		color: #fff;
	}

	.loginBox {
		text-align: center;
		width: 80%;
		margin: 20px auto 0;
	}

	.loginBox input {
		padding-left: 10px;
		height: 36px;
		line-height: 36px;
		color: #2a2a2a;
		background-color: #ffffff;
		border-top: none;
		border-left: none;
		border-right: none;
		border-bottom: 1px solid #cccccc;
		font-family: Microsoft Yahei;
		border-radius: 4px;
		-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
		box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
		-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
		transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
	}

	.loginBotton {
		width: 100%;
		font-size: 16px;
		padding: 15px 0;
		margin-top: 10px;
		background: #522e95;
		border-color: #522e95;
	}

	.loginLink {
		width: 80%;
		height: 20px;
		margin: 20px auto 40px;
	}

	.loginReg {
		float: left;
		color: #1184d5;
	}

	.loginFind {
		float: right;
		color: #1184d5;
	}

	.other-login {
		text-align: center;
		margin-top: 30px;
	}

	.other-login p {
		color: #666;
		font-size: 14px;
	}

	.other-login img {
		cursor: pointer;
		margin: 10px;
	}

	.register-code>>>.el-input__inner {
		float: left;
		width: 285px;
	}

	.register-code>>>a {
		float: left;
		position: absolute;
		left: 280px;
		width: 90px;
		top: 40px;
		height: 40px;
	}

	.fixHeight {
		height: 95px;
		margin-bottom: 0 !important;
	}

	.autoLogin {
		margin: 8px 0;
	}

	.register-title {
		text-align: center;
		font-size: 22px;
		color: #522e95;
		font-weight: bold;
		padding: 10px 0;
	}

	.register-text {
		padding: 72px 0 0 0;
		text-align: center;
		color: #999;
	}

	.identify-text {
		text-align: center;
		padding: 60px 0 160px 0;
		font-size: 18px;
	}

	.identifyBotton {
		text-align: center;
	}

	.identifyBotton a {
		display: inline-block;
		width: 80%;
		font-size: 16px;
		padding: 15px 0;
		margin-top: 10px;
		background: #522e95;
		border-color: #522e95;
		color: #fff;
		border-radius: 4px;
	}

	.identifyCancel {
		text-align: center;
		margin: 20px 0;
	}

	.identifyCancel a {
		color: #999;
	}

	.identify-title {
		text-align: center;
		font-size: 26px;
		color: #522e95;
		font-weight: bold;
		margin-top: 100px;
	}

	.hasRead {
		float: left;
		margin: 0 0 20px 20px;
	}

	.hasRead-rule {
		float: left;
		text-decoration: underline;
	}

	/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #522e95;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #522e95;
		border-color: #522e95;
	}

	/deep/ .el-checkbox__inner:hover {
		border-color: #522e95 !important;
		;
	}

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #522e95 !important;
		;
		background: #522e95 !important;
		;
	}

	/deep/ .el-radio__input.is-checked+.el-radio__label {
		color: #522e95 !important;
		;
	}

	/deep/ .el-radio__inner:hover {
		border-color: #522e95 !important;
		;
	}
</style>
